import BranchesListHeaders from './BranchesListHeaders';
import BranchesListBody from './BranchesListBody';
import './style.scss';

const MatchBranchesTable: React.FC = () => {
  return (
    <div className="d-flex flex-column flex-grow-1 pt-4">
      <>
        <BranchesListHeaders />
        <BranchesListBody />
      </>
    </div>
  );
};

export default MatchBranchesTable;
